import {TooltipAttrs} from 'common/components/tooltip/types';
import {Translatable} from 'common/i18n';

export type ToggleOption<T = string> = {
  label: Translatable;
  value: T;
  disabled?: boolean;
  icon?: string;
  iconColor?: string;
  textColor?: string;
  // Only one of tooltipLabel or tooltip should be specified
  tooltipLabel?: Translatable;
  tooltip?: TooltipAttrs;

  // For using a toggle option as a link
  href?: string;
};

export enum ToggleTheme {
  TabBar = `tab-bar`,
  TabBarBorderless = `tab-bar-borderless`,
  TabBarBorderlessCompact = `tab-bar-borderless-compact`,
  TabBarLite = `tab-bar-lite`,
  TabBarHeavy = `tab-bar-heavy`,
  SegmentedController = `segmented-controller`,
  TabBarLargeFont = `large-font`,
}

export enum ToggleSize {
  Small = `small`,
  Medium = `medium`,
  Large = `large`,
}

// We may want to add e.g. `only-icons-except-selected` in the future
export enum NarrowMode {
  OnlyIcons = `only-icons`,
}
